/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReceiptFieldResponse
 */
export interface ReceiptFieldResponse {
    /**
     * 
     * @type {string}
     * @memberof ReceiptFieldResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ReceiptFieldResponse
     */
    value?: string;
}

/**
 * Check if a given object implements the ReceiptFieldResponse interface.
 */
export function instanceOfReceiptFieldResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReceiptFieldResponseFromJSON(json: any): ReceiptFieldResponse {
    return ReceiptFieldResponseFromJSONTyped(json, false);
}

export function ReceiptFieldResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReceiptFieldResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function ReceiptFieldResponseToJSON(value?: ReceiptFieldResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
    };
}

